export default {
  setWorkExperiencesListState(state, data) {
    data = data.length ? data : [state.workExperienceItem];
    state.workExperienceErrorList = [];
    data.map(value => {
      value.isCurrent = !value.end_year;
      state.workExperienceErrorList = [state.workExperienceErrorItem, ...state.workExperienceErrorList];
    });
    state.workExperienceList = data;
  },
  mutateWorkExperienceByIndexState(state, data) {
    let list = [...state.workExperienceList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.workExperienceList = list;
  },
  addEmptyWorkExperienceItem(state) {
    state.workExperienceList = [state.workExperienceItem, ...state.workExperienceList];
    state.workExperienceErrorList = [state.workExperienceErrorItem, ...state.workExperienceErrorList];
  },
  deleteWorkExperienceItem(state, index) {
    state.workExperienceList.splice(index, 1);
    state.workExperienceErrorList.splice(index, 1);
  },
  mutateExperienceErrorItem(state, data) {
    let list = [...state.workExperienceErrorList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.workExperienceErrorList = list;
  }
};
